package com.cybersoftsolution.cybersoftsolutionweb.components.icons

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdGenerator
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.dom.I

@Composable
fun MyIco(
    modifier: Modifier = Modifier,
    id: String? = null,
    icon: String = MyIcons.CHECK,
    size: CSSLengthOrPercentageNumericValue? = null,
    color: CSSColorValue? = null
) {
    val randomId = remember {
        id ?: IdGenerator.generateUniqueId("icon")
    }
    I(
        attrs = modifier
            .id(randomId)
            .classNames(*icon.split(" ").toList().toTypedArray())
            .thenIf(
                condition = size != null,
                other = size?.let { Modifier.fontSize(it) } ?: Modifier
            )
            .thenIf(
                condition = color != null,
                other = color?.let { Modifier.color(it) } ?: Modifier
            )
            .toAttrs()
    )
}